import { inject } from '@angular/core';
import { CanActivateFn, Router, type UrlTree } from '@angular/router';
import { map } from 'rxjs';
import { AdminAuthStateService } from '../auth/auth.service';
import { PermissionService } from '../services/permission.service';

/**
 * When unauthenticated, redirect to this route (no leading slash in segments).
 * Change here if the primary sign-in page changes.
 */
export const authLoginPath = 'signin';

/**
 * All app pages behind `AppLayout` require a valid session and loaded permissions
 * (so nav links are correct on first paint after login or full page reload).
 */
export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AdminAuthStateService);
  const permissionService = inject(PermissionService);
  const router = inject(Router);
  if (!auth.isLoggedIn()) {
    const returnUrl = state.url?.trim();
    return router.createUrlTree(['/auth', authLoginPath], {
      queryParams: returnUrl && returnUrl !== '/' ? { returnUrl } : undefined,
    });
  }
  return permissionService.ensureLoaded().pipe(map(() => true));
};

/**
 * For sign-in / sign-up only: if already logged in, send to the main app (dashboard is the default child).
 */
export const guestGuard: CanActivateFn = (): boolean | UrlTree => {
  const auth = inject(AdminAuthStateService);
  const router = inject(Router);
  if (!auth.isLoggedIn()) {
    return true;
  }
  return router.createUrlTree(['/dashboard']);
};
